import type { ParityCsvField } from './types';

export const PARITY_CSV_FIELDS: Array<ParityCsvField> = [];
